import { useEffect, useState } from 'react'

import { toRequestFormApplicantSelectOption } from '../../../Request'
import { getIdwellToIdwellBoundUserInfo } from '../../IdwellToIdwell.api'

export function useIdwellToIdwellGetBoundUser(outboundCompanyUuid) {
  const [boundUser, setBoundUser] = useState(null)

  useEffect(() => {
    if (outboundCompanyUuid) {
      getIdwellToIdwellBoundUserInfo(outboundCompanyUuid).then(({ data }) => {
        setBoundUser(toRequestFormApplicantSelectOption(data))
      })
    }
  }, [outboundCompanyUuid])

  return { boundUser }
}
